import { render, staticRenderFns } from "./ProductKits.vue?vue&type=template&id=67cc3d1f&scoped=true"
import script from "./ProductKits.vue?vue&type=script&lang=js"
export * from "./ProductKits.vue?vue&type=script&lang=js"
import style0 from "./ProductKits.vue?vue&type=style&index=0&id=67cc3d1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cc3d1f",
  null
  
)

export default component.exports